import { colors as existingColors, fonts as existingFonts, size as existingSizes } from '../ColorFont/color';

export const colors = {
    ...existingColors,
    // We already have these in color.js, but mapping here directly for clarity
    background_light: existingColors.background_light || "#FFFFFF",
    background2: existingColors.background2 || "#FFFFFF",
    text: existingColors.text || "#6D786D",
    text_dark: existingColors.text_dark || "#171C17",
    border: existingColors.border || "#E3E8E3",
    primary: existingColors.primary || "colors.primary",
    primary_continue: existingColors.primary_continue || "colors.primary_dark",
    primary_light: existingColors.primary_light || "#86C59A",
    role_selected_bg: existingColors.role_selected_bg || "colors.primary_rgba_8",
    tag_bg: existingColors.tag_bg || "#F4F6F4",
    light: existingColors.light || "#FFFFFF",
};

export const fonts = {
    ...existingFonts
};

export const sizes = {
    ...existingSizes
};

export const spacing = {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px'
};

export const radius = {
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    circle: '50%',
};
